import React from 'react'
import ImgFront from '../../images/front--24.webp'
import './postCardFront.scss'

const PostCardFront = () => {
  return <img className="PostCardFront" src={ImgFront} alt="The Gavula Family – 2024" />
}

export default PostCardFront
